<template>
  <div style="padding: 0 16px">
    <a-skeleton :loading="spinning">
      <a-table :columns="columns" :pagination="pagination" :data-source="changelogs" size="small" row-key="index" @change="handleTableChange">
        <span slot="number" slot-scope="record">{{ record.index }}</span>
        <span slot="operator" slot-scope="operator">{{ operator ? operator.nickname : '系统' }}</span>
        <span slot="diffItem" slot-scope="record">
          <div v-for="(item, key) in record.value_diff" :key="key">{{ item.label }}</div>
        </span>
        <span slot="before" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="['title', 'priority', 'project_id', 'start_time', 'end_time', 'is_review', 'version_title', 'auto_to_qa', 'auto_to_qa_fail', 'workflow_back', 'add_task', 'pre_start_time', 'pre_end_time'].includes(item.value)">{{ item.before ? item.before : '--' }}</div>
              <div v-else-if="['is_temporary', 'split_done'].includes(item.value)">{{ item.before === 0 ? '否' : '是' }}</div>
              <div v-else-if="['pm', 'tech_owner', 'handlers', 'operators'].includes(item.value)">
                <user-profiles v-if="item.before && item.before.length > 0" :value="item.before" avatar />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'status'">
                <a-badge v-if="item.before !== null && storyStatus[item.before]" :status="storyStatus[item.before].status" :text="storyStatus[item.before].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.before !== null" @click="onPreview(item.before, '「变更前」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'requirement_type'">
                <a-badge v-if="item.before !== null" :color="storyTypes[item.before].color" :text="storyTypes[item.before].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'business_requirements'">
                <span v-if="item.before && item.before.length > 0">
                  <span v-for="after_id in item.before" :key="after_id">
                    {{ '【BR-' + after_id + '】' }}
                  </span>
                </span>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'name'">
                <span v-if="item.before">
                  <a @click="goToTaskDetail(item.id?.before)" style="cursor: pointer; color: #1890ff;">{{ item.before }}</a>
                  <span v-if="item.point?.before" style="margin-left: 8px; color: #666;">({{ item.point.before }}点)</span>
                </span>
                <span v-else>--</span>
              </div>
              <div v-else-if="['id', 'point', 'total_point', 'requirement_id', 'task_count', 'total_points', 'new_requirement_id', 'old_requirement_id'].includes(item.value)">{{ item.before !== null ? item.before : '--' }}</div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
        <span slot="after" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="['title', 'priority', 'project_id', 'start_time', 'end_time', 'is_review', 'version_title', 'auto_to_qa', 'auto_to_qa_fail', 'workflow_back', 'add_task', 'pre_start_time', 'pre_end_time'].includes(item.value)">{{ item.after ? item.after : '--' }}</div>
              <div v-else-if="['is_temporary', 'split_done'].includes(item.value)">{{ item.after === 0 ? '否' : '是' }}</div>
              <div v-else-if="['pm', 'tech_owner', 'handlers', 'operators'].includes(item.value)">
                <user-profiles v-if="item.after && item.after.length > 0" :value="item.after" avatar />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'status'">
                <a-badge v-if="item.after && storyStatus[item.after]" :status="storyStatus[item.after].status" :text="storyStatus[item.after].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'business_requirements'">
                <span v-if="item.after && item.after.length > 0">
                  <span v-for="after_id in item.after" :key="after_id">
                    {{ '【BR-' + after_id + '】' }}
                  </span>
                </span>
                <span v-else />
              </div>
              <div v-else-if="item.value === 'name'">
                <span v-if="item.after">
                  <a @click="goToTaskDetail(item.id?.after)" style="cursor: pointer; color: #1890ff;">{{ item.after }}</a>
                  <span v-if="item.point?.after" style="margin-left: 8px; color: #666;">({{ item.point.after }}点)</span>
                </span>
                <span v-else>--</span>
              </div>
              <div v-else-if="['id', 'point', 'total_point', 'requirement_id', 'task_count', 'total_points', 'new_requirement_id', 'old_requirement_id'].includes(item.value)">{{ item.after !== null ? item.after : '--' }}</div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
      </a-table>
    </a-skeleton>
    <preview-modal ref="previewModal" />
  </div>
</template>

<script>
import { storyChangelog } from '@/api/project/story';
import { storyStatus, storyTypes, storyReviews } from '@/utils/dictionary';

import PreviewModal from '@/pages/project/components/PreviewModal';

const columns = [
  {
    title: '序号',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: '10%',
    align: 'center',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: '15%',
    align: 'center',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: '10%',
    align: 'center',
    key: 'operation_alias',
    dataIndex: 'operation_alias'
  },
  {
    title: '变更项',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'diffItem' }
  },
  {
    title: '变更前',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'before' }
  },
  {
    title: '变更后',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'after' }
  }
];
export default {
  components: { PreviewModal },
  props: {
    storyId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      storyTypes,
      storyReviews,
      storyStatus: {
        ...storyStatus,
        6: { label: 'Prod验收中', value: 6, status: 'processing' }
      },
      spinning: true,
      projectId: parseInt(this.$route.params.project_id) || null,
      pagination: {
        size: 'small',
        total: 0,
        pageSize: this.$store.getters.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      changelogs: [],
      changelogItems: {
        title: { value: 'title', label: '标题' },
        status: { value: 'status', label: '状态' },
        add_task: { value: 'add_task', label: '添加任务' },
        workflow_back: { value: 'workflow_back', label: '流程退回' },
        auto_to_qa: { value: 'auto_to_qa', label: '自动提审' },
        auto_to_qa_fail: { value: 'auto_to_qa_fail', label: '创建提审单失败' },
        del_task: { value: 'del_task', label: '删除任务' },
        delay_end: { value: 'delay_end', label: '推迟结束时间' },
        pre_end: { value: 'pre_end', label: '提前结束时间' },
        delay_start: { value: 'delay_start', label: '推迟开始时间' },
        pre_start: { value: 'pre_start', label: '提前开始时间' },
        version_title: { value: 'version_title', label: '迭代' },
        priority: { value: 'priority', label: '优先级' },
        handlers: { value: 'handlers', label: '负责人' },
        pm: { value: 'pm', label: '产品' },
        tech_owner: { value: 'tech_owner', label: '技术负责人' },
        split_done: { value: 'split_done', label: '拆分完成' },
        operators: { value: 'operators', label: '运营' },
        end_time: { value: 'end_time', label: '结束时间' },
        business_requirements: { value: 'business_requirements', label: '业务需求' },
        is_review: { value: 'is_review', label: '评审时间' },
        description: { value: 'description', label: '描述' },
        start_time: { value: 'start_time', label: '开始时间' },
        requirement_type: { value: 'requirement_type', label: '类型' },
        is_temporary: { value: 'is_temporary', label: '临时需求' },
        project_id: { value: 'project_id', label: '项目' },
        // 新增的任务相关字段
        name: { value: 'name', label: '任务名称' },
        point: { value: 'point', label: '点数' },
        pre_end_time: { value: 'pre_end_time', label: '预计结束时间' },
        pre_start_time: { value: 'pre_start_time', label: '预计开始时间' },

        requirement_id: { value: 'requirement_id', label: '需求ID' },

      }
    };
  },
  computed: {
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(this.changelogItems);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...this.changelogItems[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    }
  },
  created() {
    this.getStoryChangelog();
  },
  methods: {
    getStoryChangelog() {
      storyChangelog({
        requirement_id: this.storyId,
        project_id: this.projectId,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.pagination.total = res.data.total;
          this.changelogs = res.data.items.map((changelog, index) => {
            return {
              index: index + 1,
              ...changelog,
              value_diff: this.diff(changelog.value_diff)
            };
          });
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },

    onPreview(content, title = null) {
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, title);
      });
    },
    goToTaskDetail(taskId) {
      if (taskId) {
        // 跳转到任务详情页面
        this.$router.push({
          path: `/project/${this.projectId}/task/detail/${taskId}`
        });
      }
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getStoryChangelog();
    }
  }
};
</script>
<style lang="less" scoped>
.diff-item {
  display: block;
}
.ql-container.ql-snow {
  border: none;
}
</style>
